"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = _interopRequireDefault(require("../common/APSelect/APSelect"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./WhiteListedWithdrawAddressSelect.css");
var _formValidations = require("../../helpers/formValidations");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('send-address__select');
var WhiteListedWithdrawAddressSelect = /*#__PURE__*/function (_React$Component) {
  function WhiteListedWithdrawAddressSelect() {
    _classCallCheck(this, WhiteListedWithdrawAddressSelect);
    return _callSuper(this, WhiteListedWithdrawAddressSelect, arguments);
  }
  _inherits(WhiteListedWithdrawAddressSelect, _React$Component);
  return _createClass(WhiteListedWithdrawAddressSelect, [{
    key: "componenDidMount",
    value: function componenDidMount() {
      this.props.fetchAccountWithdrawInfos();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isLoading && !this.props.isLoading) {
        if (this.props.options.length === 2) {
          var AccountWithdrawInfoId = this.props.options[1].value;
          this.props.resetBankField(AccountWithdrawInfoId);
          this.props.onSelect(AccountWithdrawInfoId);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var t = this.props.t;
      var _this$props = this.props,
        openWhitelistSidepane = _this$props.openWhitelistSidepane,
        positionDetails = _this$props.positionDetails;
      var info;
      // Always show "Add an address" link to allow multiple addresses
      info = /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick() {
          return openWhitelistSidepane(positionDetails);
        },
        style: {
          width: '100%'
        }
      }, "Add an address");
      return /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: this.props.name,
        customClass: baseClasses(),
        label: t(this.props.label),
        onSelect: function onSelect(bank) {
          return _this.props.onSelect(bank);
        },
        options: this.props.options,
        info: info,
        validate: [_formValidations.required, _formValidations.notDefault]
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(WhiteListedWithdrawAddressSelect, "propTypes", {
  onSelect: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].array.isRequired,
  name: _propTypes["default"].string,
  detailsLink: _propTypes["default"].string
});
_defineProperty(WhiteListedWithdrawAddressSelect, "defaultProps", {
  name: 'ExternalAddress',
  label: 'External Address'
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)('core')(WhiteListedWithdrawAddressSelect);